import { useQuery } from "@tanstack/react-query";
import { clientAPI } from "../../api/client";

async function fetchConstantData() {
  const searchOptions = {
    limit: 10000000,
    page: 1,
  };

  const searchQueryParams = new URLSearchParams(searchOptions).toString();
  
  // Fetch constant data concurrently
  const [employee] = await Promise.all([
    clientAPI("get", `/employee?${searchQueryParams}`),
  ]);
  
  // Index data by 'id' to improve lookup performance
  return {
    employee: employee?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.fullName }),
      {}
    ),
  };
}

export function useCategories(shouldFetch) {
  // Fetch constant data once
  const {
    data: constantData,
    isLoading,
    isFetching,
    refetch,
  } = useQuery({
    queryKey: ["makeupWorkRequestAdd"],
    queryFn: () => fetchConstantData(),
    enabled: shouldFetch,
    refetchOnWindowFocus: false,
  });

  return {
    constantData,
    isLoading,
    isFetching,
    refetch,
  };
}
